import { STELLAIR_REDIRECT_URI } from '../../environment/stellair'

const STELLAIR_OAUTH_CODE_KEY = 'stellair_oauth_code'

/**
 * Compare avec le pathname de STELLAIR_REDIRECT_URI : c'est exactement l'URL vers laquelle
 * Stellair redirige. Ne surtout pas dériver ce path de document.baseURI (dépend de
 * PUBLIC_URL / <base href>, qui varie entre local et prod).
 */
const isStellairOAuthCallbackPath = (pathname: string) => {
  try {
    return pathname === new URL(STELLAIR_REDIRECT_URI).pathname
  } catch {
    return false
  }
}

/**
 * Suite à la montée version de keyclaok en 26 il n'autorise plus le code dans les redirecT_uri. Stellair nous en retourne un...
 */
export const persistStellairOAuthCallbackParams = () => {
  if (!isStellairOAuthCallbackPath(window.location.pathname)) {
    return
  }

  const params = new URLSearchParams(window.location.search)
  const code = params.get('code')

  if (code && /^[a-zA-Z0-9\-_]{1,128}$/.test(code)) {
    sessionStorage.setItem(STELLAIR_OAUTH_CODE_KEY, code)
  }

  if (window.location.search) {
    window.history.replaceState({}, '', window.location.pathname)
  }
}

export const consumeStellairOAuthCode = (): string | null => {
  const codeFromStorage = sessionStorage.getItem(STELLAIR_OAUTH_CODE_KEY)

  if (codeFromStorage) {
    sessionStorage.removeItem(STELLAIR_OAUTH_CODE_KEY)
    return codeFromStorage
  }

  return new URLSearchParams(window.location.search).get('code')
}
